module.exports = __webpack_public_path__ + "media/icons/money@2x-175f04aa.png";